import { useEffect } from "react";

function calcVh() {
  document.documentElement.style.setProperty(
    "--100vh",
    window.innerHeight + "px"
  );
}

export default function ResizeHandler() {
  useEffect(() => {
    window.addEventListener("resize", calcVh);
    calcVh();
    return () => {
      window.removeEventListener("resize", calcVh);
    };
  }, []);
  return <></>;
}
